<template>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" enable-background="new 0 0 180.343 49.133" xml:space="preserve" style="">
<rect id="backgroundrect" x="0" y="0" fill="none" stroke="none" class="selected" style=""/>

<g class="currentLayer" style=""><title>Layer 1</title><g id="svg_1" class="">
    <defs>
        <rect id="dfSVGID_1_" y="0" width="180.34300231933594" height="49.132999420166016"/>
    </defs>
    <clipPath id="dfSVGID_2_">
        <use xlink:href="#dfSVGID_1_" overflow="visible" id="svg_2"/>
    </clipPath>

    <path clip-path="url(#dfSVGID_2_)" d="M9.719,0c0,0-6.034,2.506-1.974,7.364c4.06,4.859,7.493,7.487,14.75,11.847   c7.258,4.36,14.12,9.911,16.612,15.763c2.491,5.851-0.312,9.164-1.757,10.838c-1.444,1.675-2.568,2.434-2.568,2.434   s0.842-1.424-2.182-5.003c-3.025-3.579-3.784-5.519-17.804-13.313c-5.933-3.299-12.663-9.344-14.18-13.402   c-1.481-3.964,0.002-8.01,1.368-10.531C3.349,3.477,7.468,0.397,9.719,0" id="svg_7"/>
    <path clip-path="url(#dfSVGID_2_)" d="M35.501,6.355c0-2.759-2.236-4.995-4.995-4.995   c-2.759,0-4.995,2.236-4.995,4.995c0,2.759,2.236,4.995,4.995,4.995C33.265,11.35,35.501,9.114,35.501,6.355" id="svg_8"/>
    <path clip-path="url(#dfSVGID_2_)" d="M11.985,43.046c0-2.814-2.281-5.095-5.095-5.095   c-2.814,0-5.095,2.28-5.095,5.095c0,2.813,2.281,5.095,5.095,5.095C9.705,48.141,11.985,45.86,11.985,43.046" id="svg_9"/>
</g></g></svg>
</template>

<script>
export default {
    name: 'PictoSight',
}
</script>

<style lang="scss" scoped>
</style>